import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  IonButton,
  IonCard,
  IonContent,
  IonItem,
  IonPage,
  IonToggle,
  IonText,
  IonSpinner,
} from "@ionic/react";

import {
  PushNotificationSchema,
  PushNotifications,
  Token,
  ActionPerformed,
} from "@capacitor/push-notifications";


import "./NotificationType.css";
import SimpleHeaderView from "../../../push-components/SimpleHeaderView/SimpleHeaderView";
import { authActions } from "../../../store/auth";
import { getModelProfileData } from "../../../data-services/edit-profile";

import { updateTalenProfiletData } from "../../../data-services/signup";
import {
  showToastMessage,
  unauthorizedErrorCode,
  offlineErrorCode,
  somethingWentWrongErrMsg
} from "../../../common/common";
import { get } from "../../../storage/storage";
import { CapacitorHttp } from '@capacitor/core';

const NotificationType: React.FC = () => {
  const [email, setEmailNotification] = useState<any>(false);
  const [sms, setSmsNotification] = useState<any>(false);
  const [push, setPushNotification] = useState<any>(false);
  const dispatch = useDispatch();
  const [showSpinnerTillApiResponse, setShowSpinnerTillApiResponse] =
    useState<boolean>(false);

  const [refreshComponent, setRefreshComponent] = useState<boolean>(false);

  const epInit = async () => {
    let profile_data: any = await getModelProfileData();
    if (!profile_data?.success) {
      if (profile_data?.data?.errorCode == unauthorizedErrorCode) {
        dispatch(authActions.logout());
        return;
      } else if (profile_data?.data?.errorCode == offlineErrorCode) {
        showToastMessage(profile_data?.data?.message);
      } else if (profile_data?.message) {
        await showToastMessage(profile_data.message);
      } else {
        showToastMessage(somethingWentWrongErrMsg);
      }
    }
    profile_data = profile_data.data;
    setEmailNotification(
      profile_data.modelMarketing.model_receive_mail == "yes"
    );
    setSmsNotification(profile_data.modelMarketing.model_receive_sms == "yes");

    // Notifications enabled from profile and permission granted on this device
    if (profile_data.modelMarketing.model_receive_push_notification == "yes" && await checkPushNotifications() == true) {
      setPushNotification(true);
    }
  };

  const onSubmitTalentEditMinRate = async (event: any) => {
    event.preventDefault();
    setShowSpinnerTillApiResponse(true);

    let edit_profile_form: any = {
      model_receive_mail: email ? "Yes" : "No",
      model_receive_sms: sms ? "Yes" : "No",
      model_receive_push_notification: push ? "Yes" : "No",
    };

    let update_api_response = await updateTalenProfiletData({
      model: edit_profile_form,
    });
    if (update_api_response?.success) {
      await showToastMessage("Successfully Updated!");
    } else if (update_api_response?.data?.errorCode == unauthorizedErrorCode) {
      dispatch(authActions.logout());
      return;
    } else if (update_api_response?.data?.errorCode == offlineErrorCode) {
      showToastMessage(update_api_response?.data?.message);
    } else if (update_api_response?.message) {
      showToastMessage(update_api_response.message);
    } else {
      showToastMessage(somethingWentWrongErrMsg);
    }

    setShowSpinnerTillApiResponse(false);
    setRefreshComponent(!refreshComponent);
  };

  const checkPushNotifications = async () => {
    if (!process.env?.REACT_APP_IS_NATIVE) {
        return;
    }

    const permissions = await PushNotifications.checkPermissions();
    if (permissions.receive === 'granted') {
      return true;
    }

    return false;
  }

  const pushNotificationsEnable = async (checked: any) => {
    // Trigger only if enabled.
    if (!checked == true) {
      return;
    }

    if (!process.env?.REACT_APP_IS_NATIVE) {
      return;
    }
    const registerForPush = () => {
        // Register with Apple / Google to receive push via APNS/FCM
        PushNotifications.register();
        // On success, we should be able to receive notifications
        PushNotifications.addListener('registration',
            async (token: Token) => {

                const url = `${process.env.REACT_APP_HP_API_URL}/userEvent/addFirebasePushNotificationToken`;
                const options = {
                    url: encodeURI(url),
                    headers: {
                       "Content-Type": "application/json",
                        token: await get("login_user_token"),
                    },
                    data: {pushNotificationToken: token?.value}
                };
                const response = await CapacitorHttp.post(options);
            }
        );

        // Some issue with our setup and push will not work
        // PushNotifications.addListener('registrationError',
        //     (error: any) => {
        //         alert('Error on registration: ' + JSON.stringify(error));
        //     }
        // );

    }

    const permissions = await PushNotifications.checkPermissions();

    if (permissions.receive === 'granted') {
        registerForPush();
    } else {
        let res = await PushNotifications.requestPermissions();
        if (res.receive === 'denied') {
            // setHasPushNotificationsDisabled(true);
            // set("dontWantPushNotifications", true);
            // Leave the popup open, new text will appear
            // return;

            // Proceed to the next registration step (today). Pass it as a prop in the future.
            // history.push(`/BecomeAmbassador/${url_params?.talent_signup_id}`)
        }
        else {
            registerForPush();
        }
    }

    // setShowPushNotificationsPopup(false);
  }

  useEffect(() => {
    (async () => {
      await epInit();
      checkPushNotifications();
    })();
  }, [refreshComponent]);

  return (
    <IonPage>
      <SimpleHeaderView
        title="Notification Type"
        bgcolor="primary"
        buttonType="undefined"
      ></SimpleHeaderView>
      <IonContent>
        <form
          className="talent_rate__form"
          onSubmit={onSubmitTalentEditMinRate}
        >
          <div className="noti-type-container">
            <div>{email}</div>
            <div>{sms}</div>
            <div>{push}</div>
            <IonCard className="noti-type">
              <div className="noti-type__text">
                <IonText>
                  How would you like to be notified about new opportunities?
                </IonText>
              </div>
              <IonItem className="noti-type__type">
                <IonText className="noti-type__type__label">Email</IonText>
                <IonToggle
                  mode="ios"
                  slot="end"
                  checked={email}
                  onIonChange={(e) => {
                    setEmailNotification(e.detail.checked);
                  }}
                ></IonToggle>
              </IonItem>
              <IonItem className="noti-type__type ">
                <IonText className="noti-type__type__label">SMS</IonText>
                <IonToggle
                  mode="ios"
                  slot="end"
                  checked={sms}
                  onIonChange={(e) => {
                    setSmsNotification(e.detail.checked);
                  }}
                ></IonToggle>
              </IonItem>

              <IonItem className="noti-type__type no-border">
                <IonText className="noti-type__type__label">PUSH Notifications</IonText>
                <IonToggle
                  mode="ios"
                  slot="end"
                  checked={push}
                  onIonChange={(e) => {
                    pushNotificationsEnable(e.detail.checked);
                    setPushNotification(e.detail.checked);
                  }}
                ></IonToggle>
              </IonItem>
            </IonCard>
            {showSpinnerTillApiResponse ? (
              <IonButton className="form-group__button talent-rate__submit_btn">
                <IonSpinner name="dots"></IonSpinner>
              </IonButton>
            ) : (
              <IonButton
                expand="block"
                mode="ios"
                type="submit"
                className="form-group__button noti-type__submit_btn"
              >
                Submit
              </IonButton>
            )}
          </div>
        </form>
      </IonContent>
    </IonPage>
  );
};

export default NotificationType;
